(() => {
  const DRAG_THRESHOLD = 5;

  const init = () => {
    document.querySelectorAll('[data-customsirge-drag-scroll]').forEach((el) => {
      let isDown = false;
      let startX = 0;
      let startScroll = 0;
      let moved = false;

      const onDown = (e) => {
        if (e.pointerType && e.pointerType !== 'mouse') return;
        isDown = true;
        moved = false;
        startX = e.clientX;
        startScroll = el.scrollLeft;
        el.setAttribute('data-customsirge-dragging', 'true');
        try { el.setPointerCapture(e.pointerId); } catch (_) {}
      };

      const onMove = (e) => {
        if (!isDown) return;
        const dx = e.clientX - startX;
        if (Math.abs(dx) > DRAG_THRESHOLD) moved = true;
        el.scrollLeft = startScroll - dx;
      };

      const onUp = (e) => {
        if (!isDown) return;
        isDown = false;
        el.removeAttribute('data-customsirge-dragging');
        try { el.releasePointerCapture(e.pointerId); } catch (_) {}
      };

      el.addEventListener('pointerdown', onDown);
      el.addEventListener('pointermove', onMove);
      el.addEventListener('pointerup', onUp);
      el.addEventListener('pointercancel', onUp);
      el.addEventListener('pointerleave', onUp);

      el.addEventListener('click', (e) => {
        if (moved) {
          e.preventDefault();
          e.stopPropagation();
          moved = false;
        }
      }, true);

      el.addEventListener('dragstart', (e) => {
        const tag = (e.target && e.target.tagName) || '';
        if (tag === 'IMG' || tag === 'VIDEO') e.preventDefault();
      });
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
